import { Container, Row, Col } from "react-bootstrap"

const EnviosTarifa = () => {
    return <div className="bg-white">
        <Container className="bg-white">
            <Row>
                <Col>
                    <img className="w-f" src="/files/tarifa6/landingpage.jpg" />
                </Col>
            </Row>
        </Container>
    </div>
}

export default EnviosTarifa;